"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnforcerUtility = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var EnforcerUtility = exports.EnforcerUtility = /*#__PURE__*/function () {
  function EnforcerUtility() {
    (0, _classCallCheck2.default)(this, EnforcerUtility);
  }
  (0, _createClass2.default)(EnforcerUtility, null, [{
    key: "toArray",
    value: function toArray(source) {
      if (source instanceof Array) {
        return source;
      } else {
        return [source];
      }
    }
  }, {
    key: "isChipMatch",
    value: function isChipMatch(expectedChip, chips) {
      // -
      var _iterator = (0, _createForOfIteratorHelper2.default)(EnforcerUtility.toArray(chips)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var chip = _step.value;
          // -
          var matched = new RegExp("^".concat(chip.replace(/\*/g, '.*'), "$")).test(expectedChip);
          // -
          if (matched) {
            return true;
          }
        }
        // -
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }]);
  return EnforcerUtility;
}();